import { RichText } from 'prismic-reactjs';

const slugify = text =>
  text
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Uses the UID from Prismic if there is one, otherwise builds it from the title
export const getProjectSlug = project =>
  project.uid || slugify(RichText.asText(project.data.title));

export default slugify;



// WEBPACK FOOTER //
// ./src/utils/slugify.js